import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import AddOrEditTemplateComponent from './AddOrEditTemplateComponent';

export default (props) => {
    return <AddOrEditTemplateComponent location={props.location} />;   
}
